export function getOboOverrideDetails(send) {
  return (sourceAccountId, ...args) =>
    send(
      {
        path: '/v3/sourceAccounts/{sourceAccountId}/oboOverrideDetails',
        pathParameters: { sourceAccountId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
